
import axios from "axios"

const axiosInstance = axios.create({
    baseURL: "http://api.tamariaclinic.com/api/v1",
    // baseURL: "http://localhost:8081/api/v1",

})
export default axiosInstance;